import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import change from '@mailobj-browser/front/js/events/types/change.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

const onChange = object(listener, {
  type: change,
  passive,
  task: (
    select
  ) => {
    const priceContainer = one('strong', select.closest('div.ea_auth__create_premium_pack'))
    const {options, selectedIndex} = select
    const {dataset} = options[selectedIndex]
    const {price} = dataset
    const selectPplus = one('input', select.closest('div.ea_auth__create_premium_pack'))

    selectPplus.checked = true
    replaceChildren(priceContainer, price)
  }
})

export default select => {
  onChange.listen(select)
}
